import { node } from "~/util/dom";
import { IRibbonItemNewsData } from "./interfaces";
import { WIDTH_NEWS } from "./const";

interface IRibbonItemNews extends IRibbonItemNewsData {
	width?: number;
	onClick?: () => void;
}

export default class RibbonItemNews {
	_data: IRibbonItemNews;

	_dom: {
		container: HTMLDivElement;
	};

	constructor(data: IRibbonItemNews) {
		this._data = {
			width: WIDTH_NEWS,
			onClick: () => {},
			...data,
		};

		this._build();
	}

	get container() {
		return this._dom.container;
	}

	get width() {
		return this._data.width;
	}

	get data() {
		return this._data;
	}

	_build() {
		const container = node("div", { className: "ribbonItemNews" });
		const imageCont = node("div", { className: "ribbonItemNews__imageCont" });
		const textCont = node("div", { className: "ribbonItemNews__textCont" });
		const desc = node("p", { className: "ribbonItemNews__desc clamp-lines-4" });
		const bottomPart = node("div", { className: "ribbonItemNews__bottomPart" });
		const date = node("div", { className: "ribbonItemNews__date" });
		const linkCont = node("div", { className: "ribbonItemNews__linkCont" });
		const link = node("a", { className: "ribbonItemNews__link", rel: "nofollow" });

		container.style.width = `${this._data.width}px`;
		desc.textContent = this._data.desc;
		date.textContent = this._data.date;
		link.textContent = this._data.linkStr;
		link.href = this._data.linkUrl;
		link.addEventListener("click", event => {
			event.stopPropagation();
			event.preventDefault();
		});
		linkCont.append(link);

		if (this._data.image) {
			const image = node("img", { className: "ribbonItemNews__image" });

			image.src = this._data.image;
			imageCont.append(image);
		}

		bottomPart.append(date, linkCont);
		textCont.append(desc, bottomPart);
		container.append(imageCont, textCont);

		this._dom = {
			container,
		};

		container.addEventListener("click", () => {
			this._data.onClick();
		});
	}
}
